class ContentAccordionKarteikarten extends HTMLElement {

    constructor() {
        super();
    }

    disconnectedCallback() {
        // Aufräumen
        this.removeEventListeners();
    }

    connectedCallback() {
        this.accordionContents = this.querySelector('.accordion-contents');
        this.details = this.accordionContents ? this.accordionContents.querySelectorAll('details') : [];

        this.initAccordionBehavior();
    }

    // Accordion-Verhalten initialisieren
    initAccordionBehavior() {
        if (!this.accordionContents || this.details.length === 0) {
            return; // Keine Accordion-Inhalte vorhanden
        }

        this.details.forEach(detail => {
            detail.addEventListener('toggle', this.handleToggle.bind(this));
        });
    }

    // Toggle-Event Handler
    handleToggle(e) {
        const currentDetail = e.target;

        if (currentDetail.open) {
            // Schließe alle anderen Details
            this.details.forEach(d => {
                if (d !== currentDetail && d.open) {
                    d.open = false;
                }
            });

            // Verstecke alle Buttons in geschlossenen Details
            this.details.forEach(d => {
                const button = d.querySelector('.accordion-button');
                if (button) {
                    button.hidden = true;
                }
            });

            // Zeige den Button im geöffneten Detail
            const currentButton = currentDetail.querySelector('.accordion-button');
            if (currentButton) {
                currentButton.hidden = false;
            }

            // FLIP Animation ausführen
            this.animateToTop(currentDetail);
        } else {
            // Verstecke den Button beim Schließen
            const currentButton = currentDetail.querySelector('.accordion-button');
            if (currentButton) {
                currentButton.hidden = true;
            }
        }
    }

    // FLIP Animation: First, Last, Invert, Play
    animateToTop(detail) {
        // Finde das äußere Wrapper-Element (accordion-eintrag)
        const wrapper = detail.closest('.accordion-eintrag');
        if (!wrapper) return;

        const parent = wrapper.parentElement;
        const firstElement = parent.firstElementChild;

        if (wrapper !== firstElement) {
            // Sammle alle Wrapper-Elemente
            const allWrappers = Array.from(parent.querySelectorAll('.accordion-eintrag'));
            const clickedIndex = allWrappers.indexOf(wrapper);

            // Speichere die ursprünglichen Positionen ALLER Elemente
            const allPositions = allWrappers.map(el => ({
                element: el,
                firstRect: el.getBoundingClientRect()
            }));

            // Sammle alle Elemente ab dem angeklickten Element
            const elementsToMove = allWrappers.slice(clickedIndex);

            // Verschiebe alle Elemente im DOM (Karussell-Rotation)
            elementsToMove.forEach((element, index) => {
                if (index === 0) {
                    parent.insertBefore(element, firstElement);
                } else {
                    parent.insertBefore(element, elementsToMove[index - 1].nextSibling);
                }
            });

            // Fokus setzen: Mausklicks übertragen keinen Tastaturfokus auf <summary>,
            // sodass Tab sonst das Akkordeon überspringt statt zum nächsten Eintrag zu gehen.
            const summary = detail.querySelector('.accordion-summary');
            if (summary) {
                summary.focus({ preventScroll: true });
            }

            // Animiere ALLE Elemente (auch die nach unten verschobenen)
            allPositions.forEach(({ element, firstRect }, index) => {
                const lastRect = element.getBoundingClientRect();
                const deltaY = firstRect.top - lastRect.top;

                if (deltaY !== 0) {
                    // Setze z-index: Nach oben bewegte Elemente bekommen höheren z-index
                    const isMovingUp = index >= clickedIndex;
                    element.style.zIndex = isMovingUp ? '10' : '1';

                    // Setze CSS-Variable für die Distanz
                    element.style.setProperty('--move-distance', `${deltaY}px`);

                    // Setze das Element an die alte Position (ohne Transition)
                    element.classList.add('accordion-move-initial');

                    // Play: Animiere zur neuen Position
                    requestAnimationFrame(() => {
                        element.classList.remove('accordion-move-initial');
                        element.classList.add('accordion-move-animate');

                        // Cleanup nach Animation
                        setTimeout(() => {
                            element.classList.remove('accordion-move-animate');
                            element.style.removeProperty('--move-distance');
                            element.style.zIndex = '';
                        }, 500);
                    });
                }
            });
        }
    }

    // Event Listeners entfernen
    removeEventListeners() {
        if (this.details) {
            this.details.forEach(detail => {
                detail.removeEventListener('toggle', this.handleToggle);
            });
        }
    }

}

if (!customElements.get("content-accordion-karteikarten")) {
    customElements.define("content-accordion-karteikarten", ContentAccordionKarteikarten);
}
